module.exports = __webpack_public_path__ + "img/icon-triangle-down.10decd7a.svg";